export default "__VITE_ASSET__BiDtKhHp__"